var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wt-title-advanced",domProps:{"innerHTML":_vm._s(_vm.cleanMessage())}})
}
var staticRenderFns = []

export { render, staticRenderFns }